// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step .step__item[data-v-fc35f968]{width:100%}.step .step__item-link[data-v-fc35f968]{text-decoration:none;border-bottom:2px dashed #00afa1;color:inherit}.step .step__item--padding[data-v-fc35f968]{padding-bottom:16px}.step .step__item--white[data-v-fc35f968]{background:#fff}", ""]);
// Exports
module.exports = exports;
